









import {
  Component,
  Prop,
  Vue
} from "@/shared/vuepack";
import HsabImportedClaimColumnSortIcon from "@/employee/components/hsabExpenses/HsabImportedClaimColumnSortIcon.vue";
import { ClaimsPageRequestSortableColumn } from "@/shared/types";
import { useClaimStore } from "@/employee/store/claim";

@Component({
  computed: {
    ClaimsPageRequestSortableColumn () {
      return ClaimsPageRequestSortableColumn;
    }
  },
  components: { HsabImportedClaimColumnSortIcon }
})
export default class HsabImportedClaimColumnHeader extends Vue {
  claimStore = useClaimStore();

  @Prop({ required: true })
  talonClaimColumn: ClaimsPageRequestSortableColumn;

  @Prop()
  text: string;

  @Prop({ default: true })
  sortable: boolean;

  onColumnHeaderClicked (col: ClaimsPageRequestSortableColumn) {
    if (this.sortable) {
      this.claimStore.setSortColumn(col);
    }
  }

  get rowClasses () {
    return {
      "row": true,
      "managed-expense-column-header": true,
      "sortable": this.sortable,
    };
  }
}
